"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedModelRendererFactory = void 0;
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const get_1 = __importDefault(require("lodash/get"));
const react_1 = __importDefault(require("react"));
const RelatedModelRendererFactory = (viewField) => (item) => {
    if (!item || !(0, get_1.default)(item, viewField.propertyName))
        return;
    const value = item[viewField.propertyName];
    // NOTHING
    if (!value)
        return react_1.default.createElement(Text_1.default, null, "- - -");
    // POTENTIALLY MANY
    if (value instanceof Array) {
        const allPropertyName = viewField.allPropertyName;
        const allLabel = viewField.allLabel || 'All';
        const emptyLabel = viewField.emptyLabel || '- - -';
        // ALL
        if (!!allPropertyName && !!item[allPropertyName]) {
            return react_1.default.createElement(Text_1.default, null, allLabel);
        }
        // NONE
        if (value.length === 0) {
            return react_1.default.createElement(Text_1.default, null, emptyLabel);
        }
        // ONE
        if (value.length === 1) {
            return react_1.default.createElement(Text_1.default, null, value[0].title);
        }
        // MANY
        else if (value.length > 1) {
            return (react_1.default.createElement(Tooltip_1.default, { tip: react_1.default.createElement(Vertical_1.default, null, value.map((v, i) => (react_1.default.createElement(Text_1.default, { key: 'tip' + i }, v.title)))) },
                react_1.default.createElement(Text_1.default, null, value[0].title + ' +' + (value.length - 1))));
        }
        return null;
    }
    // ONLY EVER ONE
    return react_1.default.createElement(Text_1.default, null, value.title);
};
exports.RelatedModelRendererFactory = RelatedModelRendererFactory;
exports.default = exports.RelatedModelRendererFactory;
